// Internal Module Imports
import { BASE_URL_BIDDING_SERVICE } from '../../../constants';
import { HttpClient } from '../../../utils/httpClient';

const PATH = {
    get: `/${BASE_URL_BIDDING_SERVICE}/common/instance`,
    getApprovedCapacity: `/${BASE_URL_BIDDING_SERVICE}/common/instance/afrr-approved-capacity`,
    getScChargers: `/${BASE_URL_BIDDING_SERVICE}/common/instance/sc-chargers`,
};

const GetInstances = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.get}`, { params }).then(callback).catch(error).finally(next);
};

const GetInstanceApprovedCapacity = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.getApprovedCapacity}`, { params }).then(callback).catch(error).finally(next);
};

const GetScChargers = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.getScChargers}`, { params }).then(callback).catch(error).finally(next);
};

export const InstanceService = {
    GetInstances,
    GetInstanceApprovedCapacity,
    GetScChargers,
};
